import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import FocusBox from './FocusBox'

const Wrapper = styled.section`
  margin-bottom: 120px;
`

const FocusContent = styled(Col)`
  ${media.xs`
    margin-bottom: 65px;
  `}
  
  ${media.sm`
    margin-bottom: 65px;
  `}
  
  ${media.md`
    margin-bottom: 75px;
  `}

  ${media.lg`
    margin-bottom: 100px;
    
    &:nth-child(even) {
      transform: translateY(100px);
    }
  `}
  

  ${media.xl`
    margin-bottom: 200px;
    
    &:nth-child(even) {
      transform: translateY(200px);
    }
  `}
`


export default class FocusGrid extends Component {
  render() {
    const { boxes } = this.props

    return(
      <Wrapper>
        <Container fluid>
          <Row>
            {boxes.map((box, index) => {
              let humanIndex = index + 1
              let count = humanIndex < 10 ? `0${humanIndex}` : humanIndex
              
              return(
                <FocusContent
                  sm={10}
                  smOffset={1}
                  md={5}
                  mdOffset={1}
                  xl={4}
                  xlOffset={index % 2 ? 2 : 1}

                  key={index}
                >
                  <FocusBox
                    box={box}
                    count={count}
                  />
                </FocusContent>
              )
            })}
          </Row>
        </Container>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/FocusGrid/index.js